// Constants file
import Constants from '../constants/AppConstants';

export const stripAdminPrefix = (pathname = '') => {
  if (typeof pathname !== 'string') return '';
  if (pathname === '/admin') return '/';
  if (pathname.startsWith('/admin/')) return pathname.slice('/admin'.length);
  return pathname;
};

export const withAdminPrefix = (pathname = '') => {
  if (typeof pathname !== 'string') return '/admin';
  if (!pathname) return '/admin';
  if (pathname.startsWith('/booking')) return pathname;
  if (pathname === '/') return '/admin';
  if (pathname.startsWith('/admin')) return pathname;
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `/admin${normalized}`;
};

export const getApiConfigurations = () => {
  const user = JSON.parse(localStorage.getItem(Constants.FIELD.USER));
  // В dev-режиме используем относительный путь /api (проксируется на localhost:8080)
  // В production используем полный URL
  const safeBaseUrl = process.env.NODE_ENV === 'production'
    ? 'https://carmelcleveland.com/api'
    : '/api'; // Относительный путь - будет проксироваться через setupProxy.js
  const configurations = {
    baseUrl: safeBaseUrl,
    userId: user?._id || user?.id || null,
    token: localStorage.getItem(Constants.FIELD.AUTH_TOKEN),
  };
  return configurations;
};

export const getThemeConfigurations = () => {
  const configurations = JSON.parse(localStorage.getItem(Constants.FIELD.CONFIGURATIONS));
  const theme = configurations?.theme || Constants.SYSTEM.DEFAULT_THEME;
  const themeConfigurations = {
    textAlternate: theme['--text-alternate'],
    textSecondary: theme['--text-secondary'],
    textPrimary: theme['--text-primary'],
    backgroundSecondary: theme['--bg-secondary'],
    backgroundPrimary: theme['--bg-primary'],
    primary: theme['--primary'],
  };
  return themeConfigurations;
};

export const getModuleConfigurations = (props) => {
  const configurations = JSON.parse(localStorage.getItem(Constants.FIELD.DASHBOARD_CONFIGURATIONS));
  if (!configurations) {
    localStorage.clear();
  }
  const pathname = stripAdminPrefix(props?.location?.pathname || window.location.pathname);
  const stateEventKey = props?.location?.state?.eventKey;
  const stateSubEventKey = props?.location?.state?.subEventKey;

  if (!configurations?.menu || !Array.isArray(configurations.menu)) return null;

  // 1) Если есть state (навигация из меню) — используем его
  if (stateEventKey) {
    const mappingConfiguration = configurations.menu.find((item) => item.eventKey === stateEventKey);
    if (mappingConfiguration?.subMenus && stateSubEventKey) {
      const subMappingConfigurations = mappingConfiguration.subMenus.find((item) => item.eventKey === stateSubEventKey);
      if (subMappingConfigurations) return subMappingConfigurations;
    }
    if (mappingConfiguration) return mappingConfiguration;
  }

  // 2) Фолбэк: ищем конфигурацию по URL (важно для прямых заходов/refresh)
  const directMatch = configurations.menu.find((item) => item.eventKey === pathname);
  if (directMatch) return directMatch;

  for (const item of configurations.menu) {
    if (item.subMenus) {
      const subMatch = item.subMenus.find((subItem) => subItem.eventKey === pathname);
      if (subMatch) return subMatch;
    }
  }

  return null;
};

export const getTabViewConfigurations = (props) => {
  const configurations = JSON.parse(localStorage.getItem(Constants.FIELD.DASHBOARD_CONFIGURATIONS));
  if (!configurations) {
    localStorage.clear();
  }
  const pathname = stripAdminPrefix(props?.location?.pathname || window.location.pathname);
  const stateEventKey = props?.location?.state?.eventKey;
  const mappingConfiguration = configurations?.menu?.find((item) => item.eventKey === stateEventKey || item.eventKey === pathname);
  if (mappingConfiguration?.tabViewConfigurations) {
    const tabViewConfigurations = mappingConfiguration?.tabViewConfigurations;
    return tabViewConfigurations;
  }
  return {};
};

export const eventBus = {
  on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    document.removeEventListener(event, callback);
  },
};

export default eventBus;
